import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var tooltipTrigger = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1e9jm180',variantClassNames:{transparent:{true:'fx_2d2fb1e5_1e9jm181',false:'fx_2d2fb1e5_1e9jm182'}},defaultVariants:{transparent:false},compoundVariants:[]});

export { tooltipTrigger };
//# sourceMappingURL=trigger.vanilla.mjs.map
